import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddTipoDomicilio = () => {
  const [tiposDomicilio, setTiposDomicilio] = useState([]);
  const [Nombre, setNombre] = useState("");
  const [tipoEditando, setTipoEditando] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("activas");

  useEffect(() => {
    getTiposDomicilio();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre del tipo de domicilio", type: "text", required: true },
  ];

  const getTiposDomicilio = async () => {
    try {
      const response = await api.get(`/tipos-domicilio`);
      setTiposDomicilio(response.data || []);
    } catch (error) {
      console.error("Error al obtener tipos de domicilio:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron obtener los tipos de domicilio.",
      });
    }
  };

  const filtrarTiposDomicilio = () => {
    if (filtroEstado === "activas") {
      return tiposDomicilio.filter((tipo) => Number(tipo.Estado) === 1);
    }
    if (filtroEstado === "inactivas") {
      return tiposDomicilio.filter((tipo) => Number(tipo.Estado) === 0);
    }
    return tiposDomicilio;
  };

  const createTipoDomicilio = async (e) => {
    e.preventDefault();

    const nombreNormalizado = normalizar(Nombre);
    const existe = tiposDomicilio.some(
      (tipo) => normalizar(tipo.Nombre) === nombreNormalizado
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un tipo de domicilio con ese nombre.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    try {
      await api.post(`/tipos-domicilio`, { Nombre });
      await getTiposDomicilio();
      setNombre("");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El tipo de domicilio fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al guardar tipo de domicilio:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.msg || "Hubo un problema al guardar el tipo de domicilio.",
      });
    }
  };

  const handleEditTipoDomicilio = async (values) => {
    try {
      await api.put(`/tipos-domicilio/${values.IdTipoDomicilio}`, {
        Nombre: values.Nombre,
      });
      await getTiposDomicilio();
      setTipoEditando(null);
      Swal.fire({
        icon: "success",
        title: "Tipo de domicilio actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar tipo de domicilio:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.msg || "Ocurrio un error al actualizar el tipo de domicilio.",
      });
    }
  };

  const cambiarEstado = async (tipo) => {
    try {
      const nuevoEstado = Number(tipo.Estado) === 1 ? 0 : 1;
      await api.patch(`/tipos-domicilio/${tipo.IdTipoDomicilio}/toggle`);
      await getTiposDomicilio();

      Swal.fire({
        icon: "success",
        title: nuevoEstado === 1 ? "Tipo de domicilio activado" : "Tipo de domicilio desactivado",
        text: `El tipo de domicilio fue ${nuevoEstado === 1 ? "activado" : "desactivado"} correctamente.`,
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al cambiar estado de tipo de domicilio:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.msg || "Ocurrio un error al cambiar el estado del tipo de domicilio.",
      });
    }
  };

  const columnas = [
    {
      name: "Nombre",
      selector: (row) => row.Nombre,
      sortable: true,
      grow: 2,
    },
    {
      cell: (row) => (
        <button
          className="button is-small is-info mr-2 icon-pencil"
          title="Editar"
          onClick={() => setTipoEditando(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Activo",
      cell: (row) => Number(row.Estado) === 1 ? (
        <FontAwesomeIcon
          icon={faSquarePlus}
          style={{ color: "#37ff00", cursor: "pointer" }}
          size="2xl"
          onClick={() => cambiarEstado(row)}
        />
      ) : (
        <FontAwesomeIcon
          icon={faSquareMinus}
          style={{ color: "#ff0000", cursor: "pointer" }}
          size="2xl"
          onClick={() => cambiarEstado(row)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];

  const paginationOptionsES = {
    rowsPerPageText: "Filas por pagina",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el tipo de domicilio.</strong>
        </div>
        <form onSubmit={createTipoDomicilio}>
          <div className="field">
            <label className="label required">Nombre del tipo de domicilio</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ej: Domicilio principal"
                required
              />
            </div>
          </div>

          <div className="field">
            <button type="submit" className="button is-success">Guardar</button>
          </div>
        </form>

        <br />

        <div style={{ border: "1px solid gray", borderRadius: "8px" }}>
          <div style={{ display: "flex", gap: "10px", marginBottom: "1rem" }}>
            {["todas", "activas", "inactivas"].map((estado) => (
              <button
                key={estado}
                onClick={() => setFiltroEstado(estado)}
                type="button"
                style={{
                  padding: "6px 16px",
                  border: "none",
                  borderRadius: "20px",
                  backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
                  color: filtroEstado === estado ? "#075e54" : "#333",
                  fontWeight: filtroEstado === estado ? "bold" : "normal",
                  boxShadow: filtroEstado === estado
                    ? "inset 0 0 0 1px #1ebea5"
                    : "inset 0 0 0 1px #ccc",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  fontSize: "0.9rem",
                }}
              >
                {estado.charAt(0).toUpperCase() + estado.slice(1)}
              </button>
            ))}
          </div>

          <DataTable
            pagination
            paginationComponentOptions={paginationOptionsES}
            columns={columnas}
            data={filtrarTiposDomicilio()}
            dense={false}
          />
        </div>

        {tipoEditando && (
          <EditModal
            fields={editFields}
            initialValues={tipoEditando}
            onSubmit={handleEditTipoDomicilio}
            onClose={() => setTipoEditando(null)}
            title="Editar Tipo de Domicilio"
          />
        )}
      </div>
    </div>
  );
};

export default AddTipoDomicilio;